<div class="PGAttachmentEditor">
    @for (item of value; track item; let i = $index) {
        <div class="form-group {{ multi ? 'card form-group pb-2 pt-3 px-3' : ''}}">
            <div class="col-12 pb-2">
                @if (multi) {
                    <div class="float-end">
                        <button type="button" class="btn btn-danger btn-sm" [disabled]="readonly" (click)="removeItem(item)"
                            [attr.aria-label]="'pg-attachment-editor.a11y.delete' | locTranslate">
                            <i class="fa-regular fa-trash" aria-hidden="true"></i>
                        </button>
                    </div>
                }
                <label>
                    <b>{{ 'pg-attachment-editor.field-name' | locTranslate}}</b>
                </label>
                <input [id]="i == 0 ? fieldId : null" class="form-control" [readonly]="readonly" [(ngModel)]="item.name" (ngModelChange)="onValueChange()"/>
            </div>
            <div class="col-12 pb-2">
                <label>
                    <b>{{ 'pg-attachment-editor.field-file' | locTranslate}}</b>
                </label>
                <app-pg-file-picker
                    [readonly]="readonly"
                    [fileType]="fileType"
                    [fileOptions]="fileOptions"
                    [groupId]="groupId"
                    [realmId]="realmId"
                    [directoryId]="directoryId"
                    [(ngModel)]="item.url"
                    (ngModelChange)="onValueChange()">
                </app-pg-file-picker>
            </div>
        </div>
    }
    @if (multi) {
        <div class="text-end">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="readonly" (click)="addItem()">
                <i class="fa-regular fa-plus" aria-hidden="true"></i><span>{{ 'pg-attachment-editor.add-item' | locTranslate}}</span>
            </button>
        </div>
    }
</div>
